import api from './index';
import { ApiResponse, LoginResponse, SiteStatus, User } from '../types';

export const authApi = {
  /**
   * Login with email and access code
   */
  async login(email: string, accessCode: string): Promise<LoginResponse> {
    const response = await api.post<ApiResponse<LoginResponse>>('/auth/login', {
      email,
      accessCode,
    });

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Login failed');
    }

    return response.data.data;
  },

  /**
   * Logout current session
   */
  async logout(): Promise<void> {
    await api.post('/auth/logout');
  },

  /**
   * Verify current session is valid
   */
  async verify(): Promise<{ valid: boolean; user: User }> {
    const response = await api.get<ApiResponse<{ valid: boolean; user: User }>>('/auth/verify');

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Verification failed');
    }

    return response.data.data;
  },

  /**
   * Get site status (countdown, active state)
   */
  async getStatus(): Promise<SiteStatus> {
    const response = await api.get<ApiResponse<SiteStatus>>('/auth/status');

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to get status');
    }

    return response.data.data;
  },
};

export default authApi;
